const doc = [({"ja":({"adminConstantHotelMealType":({"nothing":"食事なし", "breakfast":"朝食付き", "dinner":"夕食付き", "both":"夕食・朝食付き", "all_meals":"朝食・昼食・夕食付き"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;